import { render, staticRenderFns } from "./S_Home.vue?vue&type=template&id=2383307f"
import script from "./S_Home.vue?vue&type=script&lang=js"
export * from "./S_Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports